var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDbBiomass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#DF0FA5",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2732 19.2012L17.0898 20.3625L20.4592 22.5427L22.5829 21.25L19.2732 19.2012Z",
    fill: "#E058BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4369 24.2021L17.0176 26.2835L19.3784 27.8217L22.7046 25.6694L20.4369 24.2021Z",
    fill: "#E058BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.923 22.0791L21.7695 23.3899L23.9976 24.8316L26.1351 23.4485L23.923 22.0791Z",
    fill: "#E058BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4571 24.2676L25.291 25.6691L28.6175 27.8215L30.8492 26.3673L27.4571 24.2676Z",
    fill: "#E058BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6846 19.1807L25.2695 21.2593L27.4409 22.6035L30.9053 20.3619L28.6846 19.1807Z",
    fill: "#E058BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9986 26.5059L20.668 28.661L23.9988 30.8313L27.3295 28.6611L23.9986 26.5059Z",
    fill: "#E058BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6699 21.1182L12 23.0453L15.7113 25.4329L19.126 23.3544L15.6699 21.1182Z",
    fill: "#E058BA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9971 16.7344L20.709 18.4369L23.9288 20.4301L27.2415 18.4136L23.9971 16.7344Z",
    fill: "#E058BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3258 21.1172L28.7637 23.4221L32.151 25.5191L35.996 23.0445L32.3258 21.1172Z",
    fill: "#E058BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDbBiomass);
export default __webpack_public_path__ + "static/media/icon-db-biomass.4937d05c0139b61b0f7bde588f7e38cd.svg";
export { ForwardRef as ReactComponent };